import React from 'react';
import './LoadMoreButton.css';

const LoadMoreButton = ({onClick}) => {
  return (
    <div className="text-center mt-5">
      <button className="load-more-btn" onClick={onClick}>
        <i className="fas fa-sync-alt me-2"></i>Завантажити ще
      </button>
    </div>
  );
};

export default LoadMoreButton;